import { render, staticRenderFns } from "./TransportError.vue?vue&type=template&id=318c738f&"
import script from "./TransportError.vue?vue&type=script&lang=ts&"
export * from "./TransportError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports